import React,{useState,useEffect,useRef} from "react";

import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';
import AppTopMenuCard from "./Cards/AppTopMenuCard";
import ColorThemeCard from "./DesignColor/ColorThemes/ColorThemeCard";
import HeaderThemeCard from "./DesignColor/HeaderTheme/HeaderThemeCard";


import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import ColorPicker from "../../UI/ColorPicker/Colorpicker";
import ColorThemeBarCard from "./DesignColor/ColorThemes/ColorThemeBarCard";
import AppMenuCardTwo from "./Cards/AppMenuCardTwo";
import FooterColorThemeCard from "./DesignColor/FooterTheme/FooterColorThemeCard";
// npm i @loadable/component 

let lazyLoad =   <Loading/>;
  
  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const DesignColorAll = ({})=>{
    
               const [activeCardSettings, setActiveCardSettings] =useState(false);   
            
             const [colorTheme, setColorTheme] =useState(true);   
             const [textTheme, setTextTheme] =useState(false);   
             const [buttonTheme, setButtonTheme] =useState(false);   
             const [inputTheme, setInputTheme] =useState(false);   
             const [headerTheme, setHeaderTheme] =useState(false);  
             const [footerTheme ,  setFooterTheme ] =useState(false);  
            
             const [appTopMenuBarCard, setAppTopMenuBarCard] =useState(true);   
             const [colorThemeGrid, setColorThemeGrid] =useState(true);   
             const [colorThemeList, setColorThemeList] =useState(false);   
              const dispatch = useDispatch();
                  
                   
                 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
                     {
                       
                       dispatch({type: "CURSOR",payload:true  });
                   
                       dispatch({type: "CURSORTEXT",payload:CursorText})
                       dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                       dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
                     }
                      
                     const handleMouseLeave = () => {
                       
                       dispatch({type: "CURSOR",payload:false})
                   
                       dispatch({type: "CURSORTEXT",payload:""})
                   
                       dispatch({type: "CURSORTEXTBG",payload:""})
                       dispatch({type: "CURSORTEXTCOLOR",payload:""})
                     
                   
                   }

                       const colorPickerOptionArray =[     
                               'rgba(255, 114, 94, 1)',      
                           'rgba(255, 114, 94, 0.5)', 
                                
                         'rgba(255, 255, 255, 0.9)',    
                           'rgba(255, 114, 94, 0.1)'      
                           , 'rgba(55, 71, 79, 1)',       
                           'rgba(255, 193, 0, 1)'  ];
                   
                   
                           const [activeColorPickerValue,setActiveColorPickerValue]=useState('#99cc99')
                           const [themeColor ,setThemeColor] =useState({
                             primaryColor:'rgba(255, 204, 153,1)',
                              primaryColorOpacity5:'rgba(255, 204, 153,0.5)', 
                             buttonColor:'rgba(255, 204, 153,0.9)',
                             iconColorInfo:'rgba(83, 89, 103,0.9)', 
                              activityColor:'rgba(255, 204, 153,0.1)'});
                   
 useEffect(() => {
        
 },[])
                   return (< div  className="appElementScroller">
<div className="gridForShowTwoSubCourses" style={{alignContent:"center",textAlign:"center",margin:"3px",
  
    transition: 'transform 2s ease, opacity 1s ease',
  }}>


{appTopMenuBarCard?<> <AppTopMenuCard  activeCard={colorTheme}  icon={7} title ="Color Themes" onClickPopup={
      ()=>{setColorTheme(true);;setTextTheme(false);setButtonTheme(false);;setInputTheme(false);setHeaderTheme(false)  ;setFooterTheme(false);setAppTopMenuBarCard(false); }} />

<AppTopMenuCard  activeCard={textTheme}  icon={7} title ="Text Themes" onClickPopup={
      ()=>{setColorTheme(false);;setTextTheme(true);setButtonTheme(false);;setInputTheme(false);setHeaderTheme(false) ;setFooterTheme(false);setAppTopMenuBarCard(false);   }} />

<AppTopMenuCard  activeCard={buttonTheme}  icon={7} title ="Button Designs" onClickPopup={
      ()=>{setColorTheme(false);;setTextTheme(false);setButtonTheme(true);;setInputTheme(false);setHeaderTheme(false)  ;setFooterTheme(false) ;setAppTopMenuBarCard(false); }} />
<AppTopMenuCard  activeCard={inputTheme}  icon={7} title ="Input Design & Color" onClickPopup={
      ()=>{setColorTheme(false);;setTextTheme(false);setButtonTheme(false);;setInputTheme(true);setHeaderTheme(false) ;setFooterTheme(false);setAppTopMenuBarCard(false);   }} />
<AppTopMenuCard  activeCard={headerTheme}  icon={7} title ="Header Color" onClickPopup={
      ()=>{setColorTheme(false);;setTextTheme(false);setButtonTheme(false);;setInputTheme(false); setHeaderTheme(true) ;setFooterTheme(false) ;setAppTopMenuBarCard(false); }} />
<AppTopMenuCard  activeCard={footerTheme}  icon={7} title ="Footer Color" onClickPopup={
      ()=>{setColorTheme(false);;setTextTheme(false);setButtonTheme(false);;setInputTheme(false); setHeaderTheme(false) ; setFooterTheme(true) ;setAppTopMenuBarCard(false); }} />
    </>:<><div className="gridAppFiftyAll" style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
        <AppMenuCardTwo  activeCard={appTopMenuBarCard}  icon={12} title ="Back" onClickPopup={
       ()=>{setAppTopMenuBarCard(true);  }} />
       </div><div></div>
       {colorTheme?<div className="gridAppFiftyAll" style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}> <AppMenuCardTwo  activeCard={colorThemeGrid}  icon={10} title ="Grid" onClickPopup={
   ()=>{setColorThemeGrid(true);  setColorThemeList(false);}} />
    <AppMenuCardTwo  activeCard={colorThemeList}   icon={11} title ="List" onClickPopup={
   ()=>{setColorThemeGrid(false);setColorThemeList(true);  }} /></div>:""}</>
      
}
</div>  
<div className="gridForWhatsNextAfterYTApp" style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"10px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>




<ColorPicker activeColorPickerValue={activeColorPickerValue} setActiveColorPickerValue={(color)=>{
setActiveColorPickerValue(color)}} colorPickerOptionArray={colorPickerOptionArray} /> 


{ colorTheme?<>

{colorThemeGrid?<><ColorThemeCard themeText ="Theme One" themeSubText="Timeless And Elegant" 
bgColor="rgba(61, 51, 66,1)"  textIconBG="rgba(224, 220, 215,1)" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)" buttonColor="rgba(108, 89, 65,1)" textIconButton="rgba(243, 232, 216,1)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
<ColorThemeCard themeText ="Theme One" themeSubText="Timeless And Elegant" 
bgColor="rgba(61, 51, 66,1)"  textIconBG="rgba(224, 220, 215,1)" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)" buttonColor="rgba(108, 89, 65,1)" textIconButton="rgba(243, 232, 216,1)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
</>:<>
<ColorThemeBarCard themeText ="Theme Bar One" themeSubText="Timeless And Elegant" 
bgColor="rgba(61, 51, 66,1)"  textIconBG="rgba(224, 220, 215,1)" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)" buttonColor="rgba(108, 89, 65,1)" textIconButton="rgba(243, 232, 216,1)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} }/></>}

</>: textTheme?"Text Themes":buttonTheme?"Button Themes"
   :inputTheme?"Input Themes":footerTheme?"Footer Themes":headerTheme?<><HeaderThemeCard cardType={1} themeText ="Background Color" themeSubText="Timeless And Elegant" bgColor="rgba(61, 51, 66,1)"  textIconBG="#E0DCD7" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
<HeaderThemeCard cardType={2} themeText ="Primary Color" themeSubText="Timeless And Elegant" bgColor="rgba(61, 51, 66,1)"  textIconBG="#E0DCD7" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
</>:headerTheme?<><FooterColorThemeCard cardType={1} themeText ="Background Color" themeSubText="Timeless And Elegant" bgColor="rgba(61, 51, 66,1)"  textIconBG="#E0DCD7" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
<FooterColorThemeCard cardType={2} themeText ="Primary Color" themeSubText="Timeless And Elegant" bgColor="rgba(61, 51, 66,1)"  textIconBG="#E0DCD7" primaryColor="rgba(255, 179, 158,1)"
    textIconPrimary="rgba(61, 51, 66,0.7)"
   activeCardBorder="" activeCard={activeCardSettings}  icon={7} title ="Color Themes" onClickPopup={ ()=>{} } />
</>:""}
</div> </div>
) 

}
export default DesignColorAll;